import { createUser as mutation } from "../../../lib/graphql";
import { closeHeaderModal } from "../../../actions/siteadmin/modalActions";
import { loadAccount } from "../../../actions/user/account";
import { setRuntimeVariable } from '../../../actions/runtime';
import showToaster from "../../../helpers/toastrMessgaes/showToaster";
import { setLoaderStart, setLoaderComplete } from "../../../actions/loader/loader";
import axios from "axios";
import { getDeviceId } from "../../../core/firebase/firebase";
import history from "../../../history";

import { setCookies } from "../../../helpers/Cookies/cookies";

// COMPLIANCE (CCPA/CPRA + ESIGN): version string recorded against the ToS/Privacy
// consent at signup. No queryable published-legal-document version exists on the
// web side (the api ConsentRecord otherwise defaults to '1'), so we send an
// explicit dated constant. Bump this when the Terms/Privacy copy changes.
const LEGAL_CONSENT_VERSION = '2026-06';

async function submit(values, dispatch) {
    try {
        if (!navigator.onLine) {
            showToaster({ messageId: 'networkFailed', toasterType: 'error' })
            return;
        }
        // COMPLIANCE: hard-block submit if the consent checkbox is unchecked
        // (defence-in-depth; redux-form validate also blocks it).
        if (!values?.acceptedLegal) {
            showToaster({ messageId: 'errorMessage', requestContent: 'You must accept the Terms of Service and Privacy Policy to continue.', toasterType: 'error' });
            return;
        }
        const deviceId = await getDeviceId();

        dispatch(setLoaderStart('registerLoading'));
        const params = {
            firstName: values?.firstName.trim(),
            lastName: values?.lastName.trim(),
            email: values?.email,
            phoneDialCode: values?.phoneDialCode,
            phoneNumber: values?.phoneNumber,
            phoneCountryCode: values?.phoneCountryCode,
            lat: values?.lat,
            lng: values?.lng,
            city: values?.city,
            state: values?.state,
            zipcode: values?.zipcode,
            country: values?.country,
            userType: values?.userType,
            preferredLanguage: values?.preferredLanguage,
            address: values?.address,
            preferredLat: values?.preferredLat,
            preferredLng: values?.preferredLng,
            preferredLocation: values?.preferredLocation,
            userType: 1,
            deviceId,
            referredByCode: values?.referredByCode ? String(values.referredByCode).trim() : undefined,
            // COMPLIANCE (CCPA/CPRA + ESIGN): record the accepted ToS/Privacy versions.
            acceptedTosVersion: LEGAL_CONSENT_VERSION,
            acceptedPrivacyVersion: LEGAL_CONSENT_VERSION,
        };
        const response = await axios.post('/graphql', {
            query: mutation,
            variables: params
        }, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })

        const { data } = await response?.data;
        if (data?.createUser?.status == 200) {
            setCookies({
                name: 'id_token',
                value: data?.createUser?.result?.token,
                options: { path: '/', maxAge: 1000 * data?.createUser?.result?.expiresIn }
            });
            await dispatch(loadAccount());
            await dispatch(setRuntimeVariable({
                name: 'isAuthenticated',
                value: true,
            }));
            dispatch(closeHeaderModal('registerForm'));
            dispatch(closeHeaderModal('loginModal'));
            dispatch(closeHeaderModal('verifyPhoneNumber'));
            dispatch(setLoaderComplete('registerLoading'));
            history.push(values?.referUrl ? values?.referUrl : '/dashboard');
        } else {
            dispatch(setLoaderComplete('registerLoading'));
            let errorMessage = data?.createUser?.errorMessage
            showToaster({ messageId: 'errorMessage', requestContent: errorMessage, toasterType: 'error' });
        }
    } catch (error) {
        return false;
    }
}

export default submit;